module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-split-payment-configuration"
  }, _vm._l((_vm.value), function(elem, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('DeleteConf', {
      on: {
        "click": function($event) {
          return _vm.value.splice(index, 1)
        }
      }
    }), _vm._l((elem), function(val, inx) {
      return _c('div', {
        staticClass: "column"
      }, [(inx === 'client_type_id') ? _c('SelectizeClientType', {
        attrs: {
          "selectedValue": _vm.value[index][inx]
        },
        on: {
          "optionSelected": function($event) {
            return _vm.setClientType($event, _vm.value[index])
          }
        }
      }) : _vm._e(), (inx === 'esigibilita_iva') ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "I"
        }
      }, [_vm._v("Immediata (I)")]), _c('option', {
        attrs: {
          "value": "S"
        }
      }, [_vm._v("Split Payment (S)")])]) : (inx === 'formato_trasmissione') ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "FPR12"
        }
      }, [_vm._v("Formato Privato (FPR12)")]), _c('option', {
        attrs: {
          "value": "FPA12"
        }
      }, [_vm._v("Formato PA (FPA12)")])]) : (inx === 'modalita_pagamento') ? _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.value[index][inx]),
          expression: "value[index][inx]"
        }],
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.value[index], inx, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "MP05"
        }
      }, [_vm._v("Bonifico (MP05)")]), _c('option', {
        attrs: {
          "value": "MP08"
        }
      }, [_vm._v("Carta di Credito (MP08)")])]) : _vm._e()], 1)
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36143fb2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/ItalianEInvoiceSplitPaymentConfiguration.vue
// module id = 2408
// module chunks = 1